<div class="header">
  <h1>Pending Production Manager Approval</h1>
  <mat-chip-list>
    <mat-chip color="primary" selected class="count-chip">{{ dataSource.data.length }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <p *ngIf="errorMessage" class="error-message" role="alert">{{ errorMessage }}</p>
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter contracts</mat-label>
        <input matInput (keyup)="filterContracts($event)" placeholder="ex. Jane Smith" />
      </mat-form-field>
    </div>
    <div class="table-scroll">
      <table mat-table [dataSource]="dataSource" class="table" matSort>
        <ng-container matColumnDef="contractId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract #</th>
          <td mat-cell *matCellDef="let contract">{{ contract.contractId }}</td>
        </ng-container>
        <ng-container matColumnDef="productionSchedulingNotes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Production Scheduling Notes</th>
          <td mat-cell *matCellDef="let contract" class="scheduling-notes">
            <span class="note-preview">{{ contract.productionSchedulingNotes || 'n/a' }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="projectTypes">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Types</th>
          <td mat-cell *matCellDef="let contract">{{ contract.projectTypes || 'n/a' }}</td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
          <td mat-cell *matCellDef="let contract">{{ contract.customerName || 'n/a' }}</td>
        </ng-container>
        <ng-container matColumnDef="jobAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
          <td mat-cell *matCellDef="let contract">{{ contract.jobAddress || 'n/a' }}</td>
        </ng-container>
        <ng-container matColumnDef="soldDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sold Date</th>
          <td mat-cell *matCellDef="let contract">{{ (contract.soldDate | date : 'shortDate') || 'n/a' }}</td>
        </ng-container>
        <ng-container matColumnDef="contractApprovalDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Approval Date</th>
          <td mat-cell *matCellDef="let contract">{{ (contract.contractApprovalDate | date : 'shortDate') || 'n/a' }}</td>
        </ng-container>
        <ng-container matColumnDef="contractTotal">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Total</th>
          <td mat-cell *matCellDef="let contract">{{ contract.contractTotal | currency : 'USD' }}</td>
        </ng-container>
        <ng-container matColumnDef="zoneOffice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone/Office</th>
          <td mat-cell *matCellDef="let contract">{{ contract.zoneOffice || 'n/a' }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell empty-message" [attr.colspan]="displayedColumns.length">
            <ng-container *ngIf="!isLoading && !errorMessage">No matching results</ng-container>
          </td>
        </tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="goToContract(row)"></tr>
      </table>
    </div>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>
    <mat-paginator [pageSize]="100" [pageSizeOptions]="[10, 50, 100, 150, 500]" showFirstLastButtons></mat-paginator>
  </div>
</div>
